"use strict";

/**
 * Collecting stats for the fatigue
 */
;
(function () {
  document.addEventListener('flix:load', onPageLoad);
  var _viewPercentage = 20,
    _statData = new Map(),
    _videoList = [];
  var initialized = false;
  var pageInfo;
  function getEndpoint() {
    return Flix.env == 'production' ? 'https://ac2.tnaflix.com/stats.php' : '/local/fatigue';
  }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (isMSIE() || FlixUtils.isCrawler() || !Flix.isTna()) {
      return;
    }
    _statData = new Map();
    _videoList = [];
    init();
    pageInfo = JSON.parse(document.querySelector('#page-info').textContent);
    checkVisibility();
    document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
      if (element.getAttribute('data-vid')) {
        _videoList.push(element.getAttribute('data-vid'));
      }
      element.addEventListener('click', function (e) {
        logEvent(e.currentTarget.getAttribute('data-vid'), 'thumb_click', e.currentTarget.getAttribute('data-first-thumb'), e.currentTarget.getAttribute('data-num'));
      });
    });
    if (storageAvailable('localStorage')) {
      var data2send = localStorage.getItem('ns');
      var data2sendStamp = localStorage.getItem('nss');
      if (data2send) {
        if (Date.now() - parseInt(data2sendStamp) < 1000 * 60) {
          var xhr = new XMLHttpRequest();
          xhr.open("POST", getEndpoint(), true);
          xhr.setRequestHeader('Content-type', 'application/json');
          xhr.send(data2send);
        }
      }
      localStorage.removeItem('ns');
      localStorage.removeItem('nss');
    }

    //log initial page view event
    if (_getPageInternalInfo().pageInternal == 'search') {
      _statData.set("search", {
        event: 'search',
        search_original: _getPageInternalInfo().pageInternalData,
        search_fixed: '',
        search_skip_fix: 0,
        stamp: new Date().getTime(),
        search_source: _getSearchSource()
      });
    }
    logEvent(0, 'page_view', 0, 0);
  }

  /**
   * Set initial event listeners
   */
  function init() {
    if (initialized) {
      return;
    }
    initialized = true;
    var supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassive = true;
        }
      });
      window.addEventListener("testPassive", null, opts);
      window.removeEventListener("testPassive", null, opts);
    } catch (e) {}

    //document.addEventListener('DOMContentLoaded', this.checkVisibility);
    document.addEventListener('load', checkVisibility);
    window.addEventListener('scroll', checkVisibility, supportsPassive ? {
      passive: true
    } : false);
    document.addEventListener('containerElementChanged', checkVisibility);
    //window.addEventListener("visibilitychange", this.logData);

    window.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        logData();
      }
    });
    window.addEventListener('beforeunload', function () {
      logData();
    });
    document.addEventListener('fatigueLogEvent', function (e) {
      logEvent(e.detail.VID, e.detail.eventType, e.detail.thumbIndex, e.detail.thumbPosition);
    });
    document.querySelectorAll('.badge, .badge-video > a').forEach(function (el) {
      el.addEventListener('click', function () {
        if (storageAvailable('localStorage')) {
          localStorage.setItem('search_source', 'tag');
        }
      });
    });
  }

  /**
   * Add data to stats collector on page close
   */
  function logData() {
    if (isMSIE() || isCrawler()) {
      return;
    }
    var headers = {
      type: 'application/json'
    };
    var ab = unescape(FlixUtils.getCookie('auth_bit'));
    var UID = -1;
    //if (ab) {  //ab won't be set for mobile-only users, unfortunately
    //    ab = JSON.parse(ab);
    //    UID = ab.UID;
    //}

    var res = [];
    _statData.forEach(function (val, key) {
      if (val.hasOwnProperty('duration') && val.duration === 0) {
        val.duration = Date.now() - val.start;
        delete val.start;
      }
      res.push(val);
    });
    var data = JSON.stringify({
      uid: UID,
      platform: 'mobile',
      events: res,
      statsUID: _getStatsUid(),
      refInternal: _getInternalRefPageInfo().pageInfo,
      refInternalData: _getInternalRefPageInfo().pageData,
      pageInternal: _getPageInternalInfo().pageInternal,
      pageInternalData: _getPageInternalInfo().pageInternalData,
      refDomain: _getRefDomain(),
      campaign: _getUtmCampaign(),
      searchGroup: _getTestGroupId()
    });
    if (storageAvailable('localStorage')) {
      localStorage.setItem('ns', data);
      localStorage.setItem('nss', Date.now().toString());
    }
    var sent = false;
    if (typeof navigator.sendBeacon === 'function') {
      var fd = new FormData();
      fd.append('data', data);
      sent = navigator.sendBeacon(getEndpoint(), fd);
    }
    if (!sent) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", getEndpoint(), true);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.send(data);
    }
  }
  function checkVisibility() {
    //find all videos on page, check if they're in the viewport, log those that are in
    document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
      if (element.getAttribute('data-vid')) {
        if (elementAtViewport(element, _viewPercentage)) {
          //we should actually log thumb view start stamp
          //if hidden (due to scroll, preview or click) - stop timer
          if (!_statData.has('thumb_view' + "-" + element.getAttribute('data-vid'))) {
            logEvent(element.getAttribute('data-vid'), 'thumb_view', element.getAttribute('data-first-thumb'), element.getAttribute('data-num'));
          }
        } else {
          //we should terminate view events here
          if (_statData.has('thumb_view' + "-" + element.getAttribute('data-vid'))) {
            var obj = _statData.get('thumb_view-' + element.getAttribute('data-vid'));
            if (obj.duration === 0) {
              obj.duration = Date.now() - obj.start;
              delete obj.start;
              _statData.set('event-' + Date.now().toString() + Math.floor(Math.random() * 10000), obj);
              _statData["delete"]('thumb_view-' + element.getAttribute('data-vid'));
            }
          }
        }
      }
    });
  }

  //add event to stack
  function logEvent(vid, eventType, thumbIndex, thumbPosition) {
    var _pageInfo$routeArgs$p;
    if (isMSIE()) {
      return;
    }
    var BASE_POS = (((_pageInfo$routeArgs$p = pageInfo['routeArgs']['page']) !== null && _pageInfo$routeArgs$p !== void 0 ? _pageInfo$routeArgs$p : 1) - 1) * 60;
    if (!BASE_POS) {
      var _searchParams$get;
      var searchParams = new URLSearchParams(window.location.search);
      BASE_POS = (((_searchParams$get = searchParams.get('page')) !== null && _searchParams$get !== void 0 ? _searchParams$get : 1) - 1) * 60;
    }
    if (!isNaN(parseInt(BASE_POS))) {
      thumbPosition = parseInt(thumbPosition) + parseInt(BASE_POS);
    }
    var foundCurrent = false;
    switch (eventType) {
      case 'thumb_view':
        if (_statData.has(eventType + "-" + vid)) {
          //stop
          var obj = _statData.get(eventType + "-" + vid);
          if (obj.duration === 0) {
            obj.duration = Date.now() - obj.start;
            delete obj.start;
            _statData.set('event-' + Date.now().toString() + Math.floor(Math.random() * 10000), obj);
            _statData["delete"](eventType + "-" + vid);
          }
        } else {
          //start
          _statData.set(eventType + "-" + vid, {
            vid: vid,
            event: eventType,
            thumbIndex: thumbIndex,
            thumbPosition: thumbPosition,
            start: Date.now(),
            duration: 0,
            stamp: new Date().getTime()
          });
        }
        break;
      case 'trailer_view':
        logEvent(vid, 'thumb_view', thumbIndex, thumbPosition);
        if (_statData.has(eventType + "-" + vid)) {
          //stop
          var _obj = _statData.get(eventType + "-" + vid);
          _obj.duration = Date.now() - _obj.start;
          delete _obj.start;
          _statData.set('event-' + Date.now().toString() + Math.floor(Math.random() * 10000), _obj);
          _statData["delete"](eventType + "-" + vid);
        } else {
          //start
          _statData.set(eventType + "-" + vid, {
            vid: vid,
            event: eventType,
            thumbIndex: thumbIndex,
            thumbPosition: thumbPosition,
            start: Date.now(),
            duration: 0,
            stamp: new Date().getTime()
          });

          //must have a thumb view for this and all before
          document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
            if (element.getAttribute('data-vid')) {
              if (!foundCurrent) {
                logEvent(element.getAttribute('data-vid'), 'thumb_view', element.getAttribute('data-first-thumb'), element.getAttribute('data-num'));
              }
              if (element.getAttribute('data-vid') == vid) {
                foundCurrent = true;
              }
            }
          });
        }
        break;
      case 'thumb_click':
        logEvent(vid, 'trailer_view', thumbIndex, thumbPosition);

        //must have a thumb view for this and all before
        document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
          if (element.getAttribute('data-vid')) {
            if (!foundCurrent) {
              logEvent(element.getAttribute('data-vid'), 'thumb_view', element.getAttribute('data-first-thumb'), element.getAttribute('data-num'));
            }
            if (element.getAttribute('data-vid') == vid) {
              foundCurrent = true;
            }
          }
        });
        _statData.set(eventType + "-" + vid, {
          vid: vid,
          event: eventType,
          thumbIndex: thumbIndex,
          thumbPosition: thumbPosition,
          stamp: new Date().getTime()
        });
        break;
      default:
        _statData.set(eventType + "-" + vid, {
          vid: vid,
          event: eventType,
          thumbIndex: thumbIndex,
          thumbPosition: thumbPosition,
          stamp: new Date().getTime()
        });
        break;
    }
  }
  function elementAtViewport(el) {
    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    if (el.getClientRects().length === 0) {
      return false;
    }

    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    var visible = false;

    // Checking if the element is actually visible
    if (getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden') {
      // Only top of the rect is to be checked
      if (check === 'top') {
        visible = rect.top <= (window.innerHeight || document.documentElement.clientHeight);
      } else if (check === 'full') {
        // Element is fully visible
        visible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      } else if (typeof parseInt(check) === 'number') {
        // Percent of the element's visibility
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        windowHeight = windowHeight / 2; //work only with top 50% of the screen
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        if (rect.top < 0 && rect.bottom < 0 || rect.top > windowHeight && rect.bottom > windowHeight || rect.left < 0 && rect.right < 0 || rect.left > windowWidth && rect.right > windowWidth) {
          return false;
        }
        var visibleHeight = 0;
        if (rect.top < 0) {
          if (rect.bottom > windowHeight) {
            visibleHeight = windowHeight;
          } else {
            visibleHeight = rect.bottom;
          }
        } else {
          if (rect.bottom > windowHeight) {
            visibleHeight = windowHeight - rect.top;
          } else {
            visibleHeight = rect.bottom - rect.top;
          }
        }
        var visibleWidth = 0;
        if (rect.left < 0) {
          if (rect.right > windowWidth) {
            visibleWidth = windowWidth;
          } else {
            visibleWidth = rect.right;
          }
        } else {
          if (rect.right > windowWidth) {
            visibleWidth = windowWidth - rect.left;
          } else {
            visibleWidth = rect.right - rect.left;
          }
        }
        var SFull = rect.width * rect.height;
        var SVisible = visibleHeight * visibleWidth;
        visible = SVisible > SFull * parseInt(check) / 100;
      }
    }
    return visible;
  }
  function isMSIE() {
    return window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
  }
  function isCrawler() {
    return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
  }
  function storageAvailable(type) {
    var storage;
    try {
      storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0;
    }
  }
  function _getRefDomain() {
    if (window.referrer_fallback) {
      var _ref = new URL(window.referrer_fallback);
      if (_ref.host != window.location.host) {
        FlixUtils.setCookie('_ard', _ref.host, 365);
        return _ref.host;
      }
    } else if (FlixUtils.hasCookie('_ard')) {
      return FlixUtils.getCookie('_ard');
    } else {
      return '';
    }
  }
  function _getUtmCampaign() {
    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('utm_campaign')) {
      FlixUtils.setCookie('_autmc', searchParams.get('utm_campaign'), 365);
      return searchParams.get('utm_campaign');
    } else if (FlixUtils.hasCookie('_autmc')) {
      return FlixUtils.getCookie('_autmc');
    } else {
      return '';
    }
  }
  function _getStatsUid() {
    if (FlixUtils.hasCookie('_auid')) {
      return FlixUtils.getCookie('_auid');
    } else {
      var _id = Math.random().toString().slice(2, 16);
      FlixUtils.setCookie('_auid', _id, 365);
      return _id;
    }
  }
  function _getInternalRefPageInfo() {
    var pageInfo = '';
    var pageData = '';
    if (window.referrer_fallback) {
      var _ref = new URL(window.referrer_fallback);
      if (_ref.host == window.location.host) {
        if (_ref.pathname.indexOf('/search.php') != -1) {
          pageInfo = 'search';
          var searchParams = new URLSearchParams(window.referrer_fallback);
          pageData = searchParams.get('what');
        } else if (_ref.pathname.indexOf('/video') != -1) {
          pageInfo = 'video';
          pageData = _ref.pathname.match(/\/video(\d+)/)[1];
        } else if (_ref.pathname == '') {
          pageInfo = 'index';
        }
      }
    }
    return {
      pageInfo: pageInfo,
      pageData: pageData
    };
  }
  function _getPageInternalInfo() {
    var pageInternal = '';
    var pageInternalData = '';
    var searchParams = new URLSearchParams(window.location.search);
    switch (pageInfo['currentRouteId']) {
      case 'controllers.video.view':
        pageInternal = 'video';
        pageInternalData = pageInfo['routeArgs']['vid'];
        break;
      case 'controllers.video.home':
        pageInternal = 'index';
        break;
      case 'controllers.video.category':
        pageInternal = 'category';
        pageInternalData = pageInfo['routeArgs']['categorySlug'];
        break;
      case 'controllers.video.search':
        pageInternal = 'search';
        pageInternalData = searchParams.get('what');
        break;
      case 'controllers.channel.index':
        pageInternal = 'channels';
        break;
      case 'controllers.channel.view':
        pageInternal = 'channel';
        pageInternalData = pageInfo['routeArgs']['slug'];
        break;
      case 'controllers.profile.pornstars':
        pageInternal = 'pornstars';
        break;
      case 'controllers.profile.view':
        pageInternal = 'profile';
        pageInternalData = pageInfo['routeArgs']['username'];
        break;
    }
    return {
      pageInternal: pageInternal,
      pageInternalData: pageInternalData
    };
  }
  function _getTestGroupId() {
    if (FlixUtils.hasCookie('scgi')) {
      return FlixUtils.getCookie('scgi');
    } else {
      var tgid = _getRandomInt(1, 4);
      FlixUtils.setCookie('scgi', tgid, 365);
      return tgid;
    }
  }
  function _getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function _getSearchSource() {
    if (storageAvailable('localStorage')) {
      if (localStorage.getItem('search_source')) {
        return localStorage.getItem('search_source');
      }
    }
    return '';
  }
})();